export default __webpack_public_path__ + "static/media/ag-title-en.98ef6e80.webp";